export default "__VITE_ASSET__DNN5HHrO__"